/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type UpdateGooseGameQuestMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
  title?: Types.Maybe<Types.Scalars["String"]>;
  type?: Types.Maybe<Types.GooseGameQuestType>;
  pointsRewarded?: Types.Maybe<Types.Scalars["Float"]>;
  completionLimit?: Types.Maybe<Types.Scalars["Float"]>;
  questEventActivityCategory?: Types.Maybe<Types.Scalars["String"]>;
  description?: Types.Maybe<Types.Scalars["String"]>;
  questionString?: Types.Maybe<Types.Scalars["String"]>;
  questionAnswer?: Types.Maybe<Types.Scalars["String"]>;
  flash?: Types.Maybe<Types.Scalars["Boolean"]>;
  hidden?: Types.Maybe<Types.Scalars["Boolean"]>;
  meta?: Types.Maybe<Types.Scalars["JSON"]>;
}>;

export type UpdateGooseGameQuestMutation = {
  updateGooseGameQuest: Pick<
    Types.GooseGameQuest,
    "id" | "title" | "flash" | "hidden"
  >;
};

export const UpdateGooseGameQuestDocument = gql`
  mutation UpdateGooseGameQuest(
    $id: Float!
    $title: String
    $type: GooseGameQuestType
    $pointsRewarded: Float
    $completionLimit: Float
    $questEventActivityCategory: String
    $description: String
    $questionString: String
    $questionAnswer: String
    $flash: Boolean
    $hidden: Boolean
    $meta: JSON
  ) {
    updateGooseGameQuest(
      id: $id
      title: $title
      type: $type
      points_rewarded: $pointsRewarded
      completion_limit: $completionLimit
      quest_event_activity_category: $questEventActivityCategory
      description: $description
      question_string: $questionString
      question_answer: $questionAnswer
      flash: $flash
      hidden: $hidden
      meta: $meta
    ) {
      id
      title
      flash
      hidden
    }
  }
`;

/**
 * __useUpdateGooseGameQuestMutation__
 *
 * To run a mutation, you first call `useUpdateGooseGameQuestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGooseGameQuestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGooseGameQuestMutation, { data, loading, error }] = useUpdateGooseGameQuestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      type: // value for 'type'
 *      pointsRewarded: // value for 'pointsRewarded'
 *      completionLimit: // value for 'completionLimit'
 *      questEventActivityCategory: // value for 'questEventActivityCategory'
 *      description: // value for 'description'
 *      questionString: // value for 'questionString'
 *      questionAnswer: // value for 'questionAnswer'
 *      flash: // value for 'flash'
 *      hidden: // value for 'hidden'
 *      meta: // value for 'meta'
 *   },
 * });
 */
export function useUpdateGooseGameQuestMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpdateGooseGameQuestMutation,
    UpdateGooseGameQuestMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpdateGooseGameQuestMutation,
    UpdateGooseGameQuestMutationVariables
  >(UpdateGooseGameQuestDocument, baseOptions);
}
export type UpdateGooseGameQuestMutationHookResult = ReturnType<
  typeof useUpdateGooseGameQuestMutation
>;
export type UpdateGooseGameQuestMutationResult =
  ApolloReactCommon.MutationResult<UpdateGooseGameQuestMutation>;
export type UpdateGooseGameQuestMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpdateGooseGameQuestMutation,
    UpdateGooseGameQuestMutationVariables
  >;
